// removed by extract-text-webpack-plugin
module.exports = {"spacer":"AppLayout__spacer___2WfFz","slidingContainer":"AppLayout__slidingContainer___2h6X4","container":"AppLayout__container___3df5h","header":"AppLayout__header___kBSdE","mainContainer":"AppLayout__mainContainer___x9Ao2","content":"AppLayout__content___PNx4J"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/AppLayout/AppLayout.scss
// module id = 1203
// module chunks = 1